import { useState } from "react";
import { useSession } from "../utils/SessionContext";
import api from "../api/api";
import unixTimestamp from "../utils/unixTimestamp";

const useLogRating = () => {
  const { session_id, vendorUrl, product_id } = useSession();
  
  const logRating = async (rating) => {
    const url = `/log_rating`;
    try {
      const res = await api.post(url, null, {
        params: {
          session_id,
          vendor_url: vendorUrl,
          product_id,
          rating,
          timestamp: unixTimestamp(),
        },
      });
    } catch (err) {
    }
  };

  return { logRating };
};

export default useLogRating;
